// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import "./turbo_streams"
import * as bootstrap from "bootstrap"


// MAKE BOOTSTRAP GLOBAL
window.bootstrap = bootstrap


const scrollTopOnTurbo = () => window.scrollTo(0, 0);

document.addEventListener("turbo:load", scrollTopOnTurbo);
document.addEventListener("turbo:render", scrollTopOnTurbo);

